<template>
  <div>
    <div class="row">
      <div class="col-4 box-rectangle">
        <p class="font-weight-medium mx-3 my-3">HRA - Future Payment Declaration</p>
        <!-- <iframe
              :src="form.filepath"
              style="width:100%; height:450px;"
              frameborder="0"
              /> -->
        <div class="file-title">
          <a :href="docUrl[0]" class="custom-pointer" style="text-decoration: none" target="_blank">
            <img
              class="img-icon-download-form"
              src="@/assets/download.svg"
              alt
            /><span class="add-new-document">Download Document</span>
          </a>
        </div>
      </div>
      <div class="col-4 box-rectangle">
        <p class="font-weight-medium mx-3 my-3">Future Payment Declaration</p>
        <!-- <iframe
              :src="form.filepath"
              style="width:100%; height:450px;"
              frameborder="0"
              /> -->
        <div class="file-title">
          <a :href="docUrl[1]" class="custom-pointer"  style="text-decoration: none" target="_blank">
            <img
              class="img-icon-download-form"
              src="@/assets/download.svg"
              alt
            /><span class="add-new-document">Download Document</span>
          </a>
        </div>
      </div>
      <div class="col-4 box-rectangle">
        <p class="font-weight-medium mx-3 my-3">Form 12BB</p>
        <!-- <iframe
              :src="form.filepath"
              style="width:100%; height:450px;"
              frameborder="0"
              /> -->
        <div class="file-title">
          <a :href="docUrl[2]" class="custom-pointer" style="text-decoration: none" target="_blank"> 
            <img
              class="img-icon-download-form"
              src="@/assets/download.svg"
              alt
            /><span class="add-new-document">Download Document</span>
          </a>
        </div>
      </div>
    </div>

    <!-- Popup 5 -->
    <pop-up-window
      v-if="showPopupfullviewDownloadFormsPopup"
      @back="
        showPopupfullviewDownloadFormsPopup = !showPopupfullviewDownloadFormsPopup
      "
      header="Document"
    >
      <template v-slot:content>
        <full-forms-popup
          @back="
            showPopupfullviewDownloadFormsPopup = !showPopupfullviewDownloadFormsPopup
          "
          :docUrl="docUrl"
        >
        </full-forms-popup>
      </template>
    </pop-up-window>
    <!-- End -->

    <footer>
      <popup-bottom-container>
        <template slot="end">
          <btn-grp class="form-button">
            <btn text="Back" type="secondary" @click="goBack"/>
          </btn-grp>
        </template>
      </popup-bottom-container>
    </footer>
  </div>
</template>

<script>
import fullFormsPopup from "./FullViewDownloadFormsPopup.vue";

export default {
  name: "viewDownloadFormsPopup",
  components: {
    fullFormsPopup,
  },
  props: {
    formList: {
      type: Array,
    },
  },
  data() {
    return {
      showPopupfullviewDownloadFormsPopup: false,
      docUrl: [],
    };
  },
  mounted() {
    // this.formList.forEach((element) => {
    //   //console.log(element.split("/"));
      this.docUrl=this.formList;
    // });
  },
  methods: {
    clickFile(filepath) {
      this.showPopupfullviewDownloadFormsPopup = true;
      this.docUrl = filepath;
      // this.$emit("selectedAttachment");
    },
    // Add here code for cancel button to hide popup By Bhushan 
    goBack() {
      this.$emit('back'); 
    },
  },
};
</script>

<style lang="scss" scoped>
.add-new-document {
  width: 161px;
  height: 18px;
  margin: 3px 0 3px 6px;
  font-family: Montserrat;
  font-size: 14px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #37c6c0;
}

img.img-icon-download-form {
  width: 24px;
  //transform: translate(15px, 3px);
  //float: right;
}

.document-img {
  width: 260px;
  height: 212px;
  margin: 8px;
  padding: 10px;
}

.file-title {
  width: 313px;
  //height: 58px;
  padding: 10px;
  margin-left: -1px;
  border-radius: 0px;
  //text-align: left;
  border: solid 1px #e4e4e4;
}

.file-name {
  font-weight: bold;
  color: #444444;
}

.file-size {
  display: block;
  font-size: 10px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1rem;
  letter-spacing: normal;
  color: #444444;
}

.box-rectangle {
  max-width: 313px;
  //height: 291px;
  margin: 32px 0px 0px 16px;
  border-radius: 4px;
  border: solid 1px #e4e4e4;
  text-align: center;
  padding: 0px 0px 0px;
  position: relative;
}

.custom-pointer {
  cursor: pointer;
}
</style>
